module.exports = __webpack_public_path__ + "static/img/10.9b693c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/10.png
// module id = 2Q4h
// module chunks = 0